import { useRef, useState } from 'react'
import dayjs, { type Dayjs } from 'dayjs'
import { InputBase, Typography } from '@mui/material'
import type { PropertyInputProps } from '@/objects/property-forms/PropertyInputProps.tsx'
import { ClickableArea } from '@/objects/property-forms/ClickableArea.tsx'

export interface DatePropertyInputProps extends PropertyInputProps<Dayjs | null> {
  readOnly?: boolean
}

export function DateInput({ value, onValueChange, readOnly }: DatePropertyInputProps) {
  const inputRef = useRef<HTMLInputElement>(null)
  const [focused, setFocused] = useState(false)
  const showPlaceholder = value === null && !focused

  return (
    <ClickableArea
      onClick={() => {
        if (readOnly) return
        inputRef.current?.focus()
        inputRef.current?.showPicker?.()
      }}
    >
      {showPlaceholder && <Typography sx={{ fontSize: 13, color: 'text.disabled' }}>—</Typography>}
      <InputBase
        inputRef={inputRef}
        type="date"
        value={value ? value.format('YYYY-MM-DD') : ''}
        readOnly={readOnly}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        onChange={(e) => {
          const raw = e.target.value
          onValueChange(raw ? dayjs(raw) : null)
        }}
        sx={{
          display: showPlaceholder ? 'none' : undefined,
          fontSize: 13,
          width: '100%',
          p: 0,
          '& input::-webkit-calendar-picker-indicator': {
            filter: (theme) => (theme.palette.mode === 'light' ? '' : 'invert(100%)'),
          },
        }}
      />
    </ClickableArea>
  )
}
